skrilla.controller('manualTransactionsCtrl', function ($scope, $stateParams) {
    $scope.key = "manualTransactions";
    $scope.tabs = [
        {title: "Manual Transactions", active: true},
        {title: "Manual SKR Transfers", active: false}
    ];

});
